import React from "react";
import Photos from "../../Photo";

const Banner = ({photo, text}) => {
  // allow-list 檢查，photo 需存在於 Photos 物件所定義的常數值
  const safePhoto = Object.values(Photos).includes(photo) ? photo : "";

  return (
    <div className="g-banner ban">
      <div>
        <img src={safePhoto} alt={text} />
        <div id="bannerFills"></div>
        <h2 className="h2 c">{text}</h2>
      </div>
    </div>
  );
};

export default Banner;
